export default __webpack_public_path__ + "static/media/react.6bcffb56.png";